<template>
    <div  :class="'form-group ' + getClass()">

        <input v-if="(type === 'text' || typeof type === 'undefined')" v-model="value"  type="text" :id="id" :name="name" :placeholder="placeholder" :pattern="pattern"/>

        <div class="short-label-input" v-if="(type === 'short-label')">
            <label>{{ placeholder }}</label>
            <input v-model="value"  type="text" :id="id" :name="name" :pattern="pattern"/>
        </div>

        <select v-if="(type === 'select')" v-model="value" :id="id" :name="name">
            <option v-for="option in options" :key="option.value" :value="option.value">{{option.label}}</option>
        </select>

        <phone-picker v-model="value" :val="value" v-if="(type === 'phone')" />

        <date-picker v-model="value" :val="value" v-if="(type === 'date')" />

        <postal-picker v-model="value" :val="value" v-if="(type === 'postal')" />

        <gender-picker v-model="value" :val="value" v-if="(type === 'gender')" />

        <term :id="id" v-model="value" :val="value" v-if="(type === 'term')">
            <slot name="label"></slot>
        </term>


        <form-error :show="errorsSupported() && !valid && showError()">
            <template v-slot:errorMessage>
                <slot name="errorMessage"></slot>
            </template>
        </form-error>

    </div>
</template>

<script>
    import PhonePicker from "./PhonePicker";
    import DatePicker from "./DatePicker";
    import GenderPicker from "./GenderPicker";
    import Term from "./Term";
    import FormError from "./FormError";
    import PostalPicker from "./PostalPicker";
    export default {
        name: "input-group",
        components: {PostalPicker, FormError, Term, GenderPicker, DatePicker, PhonePicker},
        props: ['placeholder', 'id', 'name', 'className', 'valid', 'type', 'options', 'val', 'pattern', "showErrors", "maxLength"],
        data: function() {
            return {
                value: ""
            }
        },
        mounted: function () {
          this.value = this.val;
        },
        methods: {
            errorsSupported: function () {
                return !(typeof this.valid === 'undefined');
            },
            showError: function () {
                let defined = !(typeof this.showErrors === 'undefined');

                return defined ? !!this.showErrors : true;
            },
            getClass() {

                let returnValue = '';

                if(this.className) {
                    returnValue = this.className;
                }

                returnValue = returnValue + ((this.errorsSupported() && !this.valid) ? ' wrong' : '');
                returnValue = returnValue + ((this.showError()) ? ' errors-visible' : '');

                return returnValue;
            }
        },
        watch: {
            value: function () {

                if(this.pattern == '\\d*' && this.value) {
                    this.value = this.value.replace(/\D/g,'');
                }

                if(this.maxLength && this.value) {
                    this.value = this.value.substr(0, this.maxLength);
                }

                this.$emit('input', this.value);
            },
            val: function () {
                this.value = this.val;
            }
        }
    }
</script>

<style scoped lang="scss">




</style>